export default __webpack_public_path__ + "static/media/institute-9-min.89ad43e1.webp";